/* eslint-disable camelcase */
export enum SimulateTypes {
  GET_SIMULATE_ALL_REQUEST = '@simulate/GET_SIMULATE_ALL_REQUEST',
  GET_SIMULATE_ALL_SUCCESS = '@simulate/GET_SIMULATE_ALL_SUCCESS',
  GET_SIMULATE_ALL_FAILURE = '@simulate/GET_SIMULATE_ALL_FAILURE',
  GET_ADDITIONAL_SERVICES_REQUEST = '@simulate/GET_ADDITIONAL_SERVICES_REQUEST',
  GET_ADDITIONAL_SERVICES_SUCCESS = '@simulate/GET_ADDITIONAL_SERVICES_SUCCESS',
  GET_ADDITIONAL_SERVICES_FAILURE = '@simulate/GET_ADDITIONAL_SERVICES_FAILURE',
  STATE_CARD_PAYMENT = '@simulate/STATE_CARD_PAYMENT',
  PLAN_ID_NAME = '@simulate/PLAN_ID',
}

export interface ServiceTypes {
  descricao: string | null;
  id: number;
  nome: string;
  plano: string;
  quantidade: number;
  status_id: number;
  valor: number;
  valor_adicional: number;
  valor_servico: number;
  valor_servico_cartao: number;
  valor_unitario: string;
}
export interface OriginalTypes {
  servicos: Array<ServiceTypes>;
  total_maximo_parcelas: number;
  valor_adicional: number;
  valor_base: number;
  valor_final: number;
  valor_negociacao: number;
  valor_parcela: number;
  valor_total_no_cartao: number;
  valor_variacao_forma_pagamento: number;
}

export interface PlanTypes {
  original: OriginalTypes;
}

export interface ServicesTypes {
  nome_servico: string;
  plano: string;
  valor_boleto: number;
  valor_cartao: number;
  id: number;
  nome: string;
}

export interface PlanDadosTypes {
  original: {
    [key: string]: {
      [key: string]: PlanTypes;
    };
  };
  package_name: string;
  plan_id: string;
  renewal: boolean;
  card_payment: boolean;
  plano: number;
  plan_name: string;
  services: Array<ServicesTypes>;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface SimulateAllState {
  simulate_all: PlanDadosTypes;
  readonly request: RequestState;
}

// -------

export interface Servico {
  id: number;
  nome: string;
  descricao: string;
  valor_servico: number;
  valor: number;
  valor_adicional: number;
  status_id: number;
  plano: string;
  quantidade: number;
  valor_unitario: string;
}
export interface DadosPlano {
  total_maximo_parcelas: number;
  valor_base: number;
  valor_adicional: number;
  servicos: Servico[];
  valor_negociacao: number;
  valor_variacao_forma_pagamento: number;
  valor_final: number;
  valor_parcela: number;
}
export interface Plano {
  original: DadosPlano;
}

export type FormaPagamento = 'invoice' | 'card';

export type PlanosFormaPagamento = {
  [forma in FormaPagamento]: Plano;
};

type Pacotes = {
  [pacote: string]: PlanosFormaPagamento;
};

export interface PackagesResponse {
  [prazo: string]: Pacotes;
}
